// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PtoIssuesCloseOutlinedSvg from "@fishx/icons-svg/es/asn/PtoIssuesCloseOutlined";
import FishxIcon from '../components/FishxIcon';

var PtoIssuesCloseOutlined = function PtoIssuesCloseOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PtoIssuesCloseOutlinedSvg
  }));
};

PtoIssuesCloseOutlined.displayName = 'PtoIssuesCloseOutlined';
export default React.forwardRef(PtoIssuesCloseOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PtoIssuesCloseOutlined.js
// module id = 3901
// module chunks = 0